import { all, call, take, race } from 'redux-saga/effects';

import storyOrTest from 'utility/tools/storyOrTest';

import account from './account/accountSagas';
import apiRootSaga from './api/apiRootSaga';
import { sagas as availableAssets } from './availableAssets';
import { sagas as basket } from './basket';
import { sagas as cart } from './cart';
import { sagas as cartStack } from './cartStack';
import { sagas as dnsSagas } from './dns';
import { sagas as favorites } from './favorites';
import gtmSagas from './gtm/sagas';
import paymentForm from './paymentForm/sagas';
import navTrackerSagas from './navTracker/sagas';
import wpSagas from './www-api/wwwSagas';
import { sagas as contact } from './contact';
import internalOnlySagas from './internalOnly/sagas';
import maintenanceModeSagas from './maintenanceMode/sagas';
import manageRedirectSagas from './manageRedirect/sagas';
import notificationsSagas from './notifications/sagas';
import { sagas as payment } from './payment';
import renewDialogSagas from './renewDialog/sagas';
import { sagas as routeSagas } from './route';
import { sagas as primaryCategoryMappingSagas } from './primaryCategoryMapping';
import { sagas as serverSagas } from './server';
import serviceWorkerSagas from './serviceWorker/sagas';
import sshkeysSagas from './sshkeys/sagas';
import usertaskSagas from './usertask/sagas';
import { sagas as reactGator } from './reactGator';
import { sagas as utility } from './utility';
import { domainRegistrationSagas } from './domainRegistration';
import watchCartAbandon from './cart/watchCartAbandon';
import adminCartsSagas from './adminCarts/sagas';
import { oidcActions } from './oidc/redux';

// Sagas that require the user authentication to be completed first
function* authenticatedSagas() {
	yield take(oidcActions.USER_FOUND);

	yield race({
		parallel: all([
			call(navTrackerSagas),
			call(paymentForm),
			call(notificationsSagas),
			call(account),
		]),
		cancelled: take(oidcActions.USER_EXPIRED),
	});
}

export default function* rootSaga() {
	yield all([
		call(adminCartsSagas),
		call(apiRootSaga),
		call(authenticatedSagas),
		call(availableAssets),
		call(basket),
		call(cart),
		call(cartStack),
		call(contact),
		call(dnsSagas),
		call(domainRegistrationSagas),
		call(favorites),
		// We don't want this injected js in our tests or stories
		!storyOrTest() && call(gtmSagas),
		call(internalOnlySagas),
		call(maintenanceModeSagas),
		call(manageRedirectSagas),
		call(payment),
		call(primaryCategoryMappingSagas),
		call(reactGator),
		call(renewDialogSagas),
		call(routeSagas),
		call(serverSagas),
		call(serviceWorkerSagas),
		call(sshkeysSagas),
		call(usertaskSagas),
		call(utility),
		call(watchCartAbandon),
		call(wpSagas),
	]);
}
